import WikiMenuItem from './wiki-menu-item';
import { CreateFolderIcon, PlusIcon, SearchIcon } from '../../../../common/ui/icons';
import { WikiMode } from '../../wiki-interfaces';
import { NavLink, useNavigate } from 'react-router-dom';
import WikiMenuDragTarget from './wiki-menu-drag-target';
import WikiMenuUploadButton from './wiki-menu-upload-btn';
import { closeMobileMenu } from '../../../../menu/ui/mobile-menu-provider';
import { useWikiStore } from '../../data/wiki-store';

const WikiMenu = () => {

    const navigate = useNavigate();

    const wikiData = useWikiStore(store => store.wikiData);
    const setWikiMode = useWikiStore(store => store.setWikiMode);

    const wikiSelectedPath = useWikiStore(store => store.wikiSelectedPath);
    const setWikiSelectedPath = useWikiStore(store => store.setWikiSelectedPath);

    const startAddNewDocument = () => {
        setWikiMode(WikiMode.NEW_DOCUMENT);
    };

    const startAddNewFolder = () => {
        setWikiMode(WikiMode.NEW_FOLDER);
    };

    const selectWikiRoot = async () => {
        const newPath = '/wiki';

        setWikiSelectedPath(newPath);
        setWikiMode(WikiMode.HOME);
        navigate(newPath);
    };

    return (
        <>
            {
                wikiData &&
                <div
                    className="side-menu flex flex-col xl:w-[350px] bg-slate-800 text-slate-100 leading-7 h-screen color-scheme-dark">
                    <div className="overflow-auto">

                        <div className="p-3 flex items-center sticky top-0 z-50 bg-slate-800">
                            <button
                                className={ `text-sm ${ wikiSelectedPath === '/wiki' ? 'text-amber-300' : 'text-slate-400' }` }
                                onClick={ selectWikiRoot }
                                type="button">
                                WIKI Root
                            </button>

                            <div className="flex items-center ml-auto">

                                <WikiMenuUploadButton/>

                                <button
                                    onClick={ startAddNewFolder }
                                    className="ml-auto"
                                    type="button">
                                    <CreateFolderIcon color={ '#94A3B8' } classes="ml-3"/>
                                </button>

                                <button
                                    onClick={ startAddNewDocument }
                                    className="ml-auto"
                                    type="button">
                                    <PlusIcon color={ '#94A3B8' } classes="ml-4"/>
                                </button>
                            </div>
                        </div>

                        <div className="pl-1">

                            <NavLink
                                onClick={ closeMobileMenu }
                                to={ `/wiki/search` }
                                className="pb-2 mb-2 flex items-center">

                                <SearchIcon
                                    size={ 20 }
                                    classes="ml-1 mr-1"
                                    color={ '#fff' }
                                />

                                <p>Search</p>

                            </NavLink>

                            <WikiMenuDragTarget itemPath={ '/' }/>

                            {
                                wikiData.fileSystemItems.map(item => {
                                    return (
                                        <WikiMenuItem
                                            key={ item.path }
                                            item={ item }
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    )
};

export default WikiMenu;